import { pick } from 'ramda';
import STATE_NAMESPACE from '../namespace';
import { defaultUpdatesState } from './reducer';
import type { UpdatesSelectorState } from './types';

export const getCancellationStatus = (state: UpdatesSelectorState) =>
  state[STATE_NAMESPACE].cancellation;
export const pruneUnknownStateProps = pick(Object.keys(defaultUpdatesState));
